<template>
    <div style="background-color: #F4F4F4;overflow: hidden">
        <div>
            <home_head></home_head>
        </div>
        <div class="body_list">
            <div class="liaotian_jm">
                <div style="position: relative;margin-top: 20px;margin-left: 40px">
                    <span v-if="userinfo_name == null || userinfo_name == ''" style="font-size: 15px;">暂无用户名</span>
                    <span v-else style="font-size: 15px;">{{userinfo_name}}</span>
                    <span @click="fanhui"
                          style="float: right;margin-right: 10%;
                          color: #00a2d4;cursor: pointer;">
                        返回上一页
                    </span>
                </div>
                <el-divider></el-divider>
                <div class="content" ref="msg-box">
                    <!--                    历史消息-->
                    <div v-for="(item,index) in list_history" :key="index" class="content_list">
                        <div class="content_av" style="width: 100%">
                            <div v-if="item.member_id != me_id">
                                <img class="img" v-if="userinfo_avatar" :src="url + '/storage/' + userinfo_avatar">
                                <img class="img" v-else-if="userinfo_avatar == '' || userinfo_avatar == null" :src="userinfo_avatar1">
                                <img class="img" v-else src="../../../assets/home/yixiaoxing_head.png">
                                <div class="span_time">{{ item.create_at }}</div>
                                <div class="content_message">
                                    <span>{{ item.msg }}</span>
                                </div>
                            </div>
                            <!--                            我的-->
                            <div v-else>
                                <img class="img1" v-if="data_img" :src="url + '/storage/' + auth_img">
                                <img class="img1" v-else  src="../../../assets/home/yixiaoxing_head.png">
                                <div class="span_time1">{{ item.create_at }}</div>
                                <div class="content_message1">
                                    <span>{{ item.msg }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--                发送的消息-->
                    <div style="margin-top: 20px">
                        <div v-for="(item,index) in list" :key="index+10000" class="content_list2">
                            <div class="content_av2" style="width: 100%">
                                <!--                                我的-->
                                <div v-if="item.member_id == me_id">
                                    <img class="img2" v-if="auth_img" :src="url + '/storage/' + auth_img">
                                    <img class="img2" v-else src="../../../assets/home/yixiaoxing_head.png">
                                    <span class="span_time2">{{ item.create_at }}</span>
                                    <div class="content_message2">
                                        <span>{{ item.messages }}</span>
                                    </div>
                                </div>
                                <div v-else>
                                    <img class="img3" v-if="userinfo_avatar" :src="url + '/storage/' + userinfo_avatar">
                                    <img class="img3" v-else-if="userinfo_avatar === null || userinfo_avatar == ''" :src="userinfo_avatar1">
                                    <img class="img3" v-else src="../../../assets/home/yixiaoxing_head.png">
                                    <span class="span_time3">{{ item.create_at }}</span>
                                    <div class="content_message3">
                                        <span>{{ item.messages }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <el-divider></el-divider>
                <div>
                    <el-input v-model="value" size="small" type="textarea" :rows="4"
                              placeholder="点击编辑消息. . ."
                              @keydown.enter.native="sendMsg($event)"
                              style="width: 90%;margin-left: 5%;min-height: 100px"></el-input>
                    <el-button style="margin-left: 70%;margin-bottom: 20px" @click="qixiao">取消</el-button>
                    <el-button type="primary" @click="sendMsg($event)">发送</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import head from "../../common/head";
  export default {
    name: "chat_room",
    data() {
      return {
        value: '',
        ws: null,
        accept_id: 0,
        token: null,
        list: [],
        history_list: [],
        auth_list: [],
        data_list: [],
        message: '\xa0\xa0\xa0\xa0',
        auth_img: '', //用户头像
        auth_username: '', //用户名
        data_img: '',//店铺头像
        url: '',
        me_id: '',//自己的uid
        list_history: [],//买家历史记录
        merchant_history: [],//商家历史记录
        userinfo_name:'',//对方用户名
        userinfo_avatar:'',//对方头像1
        userinfo_avatar1:'',//对方头像2
      }
    },
    methods: {
      chat_room() {
        let t = this;
        t.token = localStorage.getItem('uid');
        if (t.token == null) {
          window.location.href = '/user.html'
        } else {
          let id = this.$route.params.id;
          // todo 连接 websocket
          t.ws = new WebSocket("wss://ws.yi-mix.com/chat/ws?id=" + id);

          t.ws.onopen = (res) => {
            console.log(res, '连接成功');
            t.getHistory();
          };
          //获取信息
          t.ws.onmessage = function (res) {
            let resData = JSON.parse(res.data);
            if (resData.status == 201) {
              if (resData.accept_id != 0) {    //发送成功的消息
                t.list.push(resData);
              }
            }
            if (resData.status == 200) {   //历史记录
              if (resData.accept_id != 0) {
                t.history_list.unshift(resData)
              }
            }
          };

          t.ws.onclose = (res) => {
            console.log(res, '服务器关闭连接');
            setTimeout(() => {
              t.chat_room();
            }, 1000)
          };

          t.ws.onerror = (res) => {
            console.log(res, '服务器连接出错');
            setTimeout(() => {
              t.chat_room();
            }, 1000)
          };
        }
      },
      //取消发送
      qixiao() {
        this.value = '';
      },
      fanhui() {
        this.$router.go(-1);
      },
      //发送消息
      sendMsg(event) {
        if (this.value != '') {
          var data = {
            accept_id: this.fasong_id,
            type: 2,
            msg: this.value,
          };
          this.value = '';
          this.ws.send(JSON.stringify(data));
        } else {
          this.$message.warning('不能发送空消息');
        }
        if (event) {
          if (event.keyCode === 13) {   //键盘事件是enter 阻止浏览器默认的回车换行行为
            event.preventDefault();
          }
        }
      },
      //历史记录
      getHistory: function () {
        var data = {
          accept_id: this.fasong_id,
          type: 1,
          msg: '',
        };
        if (this.ws.readyState == 1) {
          this.ws.send(JSON.stringify(data));
        }
      },
      //买家历史记录
      get_history() {
        let t = this;
        if (document.location.protocol == 'http:'){
          let url = 'http://ws.yi-mix.com/chat/buyer/history?shopuid=' + this.fasong_id + '&uid=' + this.me_id;
          t.axios.get(url).then(res => {
            t.list_history = res.data
            t.list_history.reverse();   //将数组倒叙
          })
        }else {
          let url1 = 'https://ws.yi-mix.com/chat/buyer/history?shopuid=' + this.fasong_id + '&uid=' + this.me_id;
          t.axios.get(url1).then(res => {
            t.list_history = res.data
            t.list_history.reverse();   //将数组倒叙
          })
        }
      },
      //商家历史记录
      mer_history() {
        let t = this;
        if (document.location.protocol == 'http:'){
          let url = 'http://ws.yi-mix.com/chat/shoper/history?shopuid=' + this.fasong_id + '&uid=' + this.me_id;
          t.axios.get(url).then(res => {
            t.merchant_history = res.data
            t.merchant_history.reverse();
          })
        }else {
          let url1 = 'https://ws.yi-mix.com/chat/shoper/history?shopuid=' + this.fasong_id + '&uid=' + this.me_id;
          t.axios.get(url1).then(res => {
            t.merchant_history = res.data
            t.merchant_history.reverse();
          })
        }
      },
      //用户信息
      get_userlist() {
        let t = this;
        let aid = localStorage.getItem('uid');
        let url = window.config.api_url + '/user/info?token=' + aid;
        t.axios.get(url).then((res) => {
          t.auth_list = res.data
          t.auth_img = res.data.avatar  //用户头像
          t.auth_username = res.data.name //用户名
        })
      },
      get_idlist() {
        let t = this;
        let aid = localStorage.getItem('uid');
        let url = window.config.api_url + '/user/shop/info?token=' + aid;
        t.axios.get(url).then((res) => {
          t.data_id = res.data.shop_info.uid
          t.data_img = res.data.shop_info.shop_pic//店铺封面
        })
      },
      get_userinfo(){
        this.fasong_id = this.$route.query.uid;   //对方的uid
        let t = this;
        let aid = localStorage.getItem('uid');
        let url = window.config.api_url + '/user/other/user/info/' + this.fasong_id + '?token=' + aid;
        t.axios.get(url).then(res=>{
          t.userinfo_name = res.data.name   //对方用户名
          t.userinfo_avatar = res.data.avatar   //对方头像1
          t.userinfo_avatar1 = res.data.wechat_avatar   //对方头像2
        })
      },
    },
    components: {
      'home_head':head,
    },
    //滚动到自动滚动到最底部
    updated() {
      let el = this.$refs["msg-box"];
      el.scrollTop = el.scrollHeight;
    },
    created() {
      this.chat_room();
      this.get_userlist();
      this.get_idlist();
      this.get_userinfo();
      this.url = window.config.api_url;
      this.me_id = this.$route.params.id;   //自己的uid
      this.fasong_id = this.$route.query.uid;   //对方的uid
      // if (location.href.indexOf("#reloaded") == -1) {    //页面进来后强制刷新一次，不然可能发不出去消息
      //   location.href = location.href + "#reloaded";
      //   location.reload();
      // }
    },
    mounted() {
      this.get_history();
      this.mer_history();

    }
  }
</script>

<style scoped lang="less">
    .body_list {
        background-color: white;
        min-height: 700px;
        height: 100%;
        width: 70%;
        margin: 35px 15%;
        overflow: hidden;
    }

    .liaotian_jm {
        background-color: #F4F4F4;
        height: 750px;
        width: 90%;
        margin: 10px 5%;
        border-radius: 10px;
        overflow: hidden;
    }

    .content {
        overflow: auto;
        height: 60%;
        margin: 0px 30px;
        min-height: 430px;

        .content_list {
            display: flex;

            .content_av {
                margin-top: 30px;

                .content_message {
                    float: left;
                    background-color: white;
                    padding: 10px;
                    word-wrap: break-word;
                    border-radius: 0px 16px 16px 16px;
                    margin-left: 45px;
                    margin-right: 50px;
                    max-width: 750px;
                }

                .content_message1 {
                    background-color: skyblue;
                    padding: 10px;
                    border-radius: 16px 0px 16px 16px;
                    word-wrap: break-word;
                    float: right;
                    margin-top: 19px;
                    margin-right: -112.5px;
                    max-width: 750px;
                }

                .img {
                    height: 40px;
                    width: 40px;
                    border-radius: 50%;
                }

                .img1 {
                    height: 40px;
                    width: 40px;
                    float: right;
                    border-radius: 50%;
                    margin-right: 20px;
                }

                .span_time {
                    color: #8c939d;
                    display: flex;
                    margin-left: 45px;
                    margin-top: -50px;
                }

                .span_time1 {
                    float: right;
                    margin-right: 4px;
                    color: #8c939d;
                }
            }
        }
    }

    .content {
        overflow: auto;
        height: 60%;
        margin: 0px 30px;
        min-height: 430px;

        .content_list2 {
            display: flex;

            .content_av2 {
                margin-top: 30px;

                .content_message2 {
                    background-color: skyblue;
                    padding: 10px;
                    border-radius: 16px 0px 16px 16px;
                    word-wrap: break-word;
                    float: right;
                    margin-right: -112.5px;
                    margin-top: 19px;
                    max-width: 750px;
                }

                .img2 {
                    height: 40px;
                    width: 40px;
                    float: right;
                    border-radius: 50%;
                    margin-right: 20px;
                }

                .span_time2 {
                    float: right;
                    margin-right: 4px;
                    color: #8c939d;
                }
            }
        }
    }

    .content {
        overflow: auto;
        height: 60%;
        margin: 0px 30px;
        min-height: 430px;

        .content_list2 {
            display: flex;

            .content_av2 {
                margin-top: 30px;

                .content_message3 {
                    float: left;
                    background-color: white;
                    padding: 10px;
                    word-wrap: break-word;
                    border-radius: 0px 16px 16px 16px;
                    margin-left: 45px;
                    margin-right: 50px;
                    max-width: 750px;
                }

                .img3 {
                    height: 40px;
                    width: 40px;
                    border-radius: 50%;
                }

                .span_time3 {
                    color: #8c939d;
                    display: flex;
                    margin-left: 45px;
                    margin-top: -50px;
                }
            }
        }
    }
</style>